import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListaAdminGrupoService {

  constructor(private http:HttpClient) { }

  buscaGrupos(data:any) {
    return this.http.get(API + '/accessProfile',{params:data});
  }
  
  buscaMenus(data:any){
    return this.http.get(API + '/accessRole',{params:data});
  }


}
